import { cn } from "@/lib/utils";
import { fill } from "@/lib/i18n/fill";
import { PROTOCOL_STEPS, protocolStepNumber, type ProtocolStep } from "./steps";
import type { Translations } from "@/lib/i18n/types";

type ProtocolCopy = Translations["pm"]["issues"]["protocol"];

export function ProtocolStepIndicator({ step, copy }: { step: ProtocolStep; copy: ProtocolCopy }) {
  const current = protocolStepNumber(step);
  const total = PROTOCOL_STEPS.length;
  return (
    <div className="flex items-center gap-3 text-xs font-medium text-muted-foreground">
      <span>{fill(copy.step, { current: String(current), total: String(total) })}</span>
      <div className="flex flex-1 gap-1" aria-hidden="true">
        {PROTOCOL_STEPS.map((name, index) => (
          <span
            key={name}
            className={cn("h-1 flex-1 rounded-full", index < current ? "bg-primary" : "bg-muted")}
          />
        ))}
      </div>
    </div>
  );
}
